import React, { useContext } from 'react'; 
import Context from '../../Context'; 
function Support(){
    const cx=useContext(Context);    
    cx.breadCrumbsAdd(cx.t("pages.support")); 
    return(
        <div className="d-flex flex-column-fluid">				 
            <div className="container"> 
                <div className="alert alert-custom alert-warning" role="alert">                     
                    <div className="alert-text">Извините, техническая поддержка недоступна</div>
                </div>
            </div>
        </div>
    )
}
export default Support;